import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { isAuth } from 'client/features/session/actions'
import { isomorphicAuth } from 'client/features/session/sagas'
import Flashes from 'client/features/flashes/containers/Flashes.jsx'
import URLS from 'constant/URLS'
import ProgressBar from 'client/features/progressBar/components/ProgressBar.jsx'

class App extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        //this.props.dispatch(isAuth())
    }

    render() {
        return (
            <div>
                <Flashes />
                { this.props.children }
                <ProgressBar />
            </div>
        )
    }
}

App.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

//const preload = () => [[isomorphicAuth]]
//App.preload = preload

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/client/features/app/containers/App.jsx